// extracted by mini-css-extract-plugin
export default {"insurance":"virtualPayment_insurance__nAYAu","selfPay":"virtualPayment_selfPay__6lXrR","selfPayButton":"virtualPayment_selfPayButton__-zIGl"};